import type { Template } from "@/types";

export const PO_05_H2_V3: Template[] = [
{
    id: "po-05-h2v3-01",
    name: "PO 01 - H2V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h2_v3_01.png",
    size: [1136, 854],
    style: {},
        slots: [          
            { id: "1", x: 69, y: 170, width: 212, height: 349, rotation: 0, imageRotation: 0 },
            { id: "2", x: 289, y: 170, width: 211, height: 349, rotation: 0, imageRotation: 0 },
            { id: "3", x: 69, y: 527, width: 212, height: 158, rotation: 0, imageRotation: 0 },
            { id: "4", x: 289, y: 527, width: 211, height: 158, rotation: 0, imageRotation: 0 },
            { id: "5", x: 640, y: 76, width: 424, height: 705, rotation: 0, imageRotation: 0 }
        ],
},

{
    id: "po-05-h2v3-02",
    name: "PO 02 - H2V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h2_v3_02.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 27, y: 0, width: 513, height: 854, rotation: 0, imageRotation: 0 },
        { id: "2", x: 628, y: 152, width: 220, height: 373, rotation: 0, imageRotation: 0 },
        { id: "3", x: 856, y: 152, width: 220, height: 373, rotation: 0, imageRotation: 0 },
        { id: "4", x: 628, y: 533, width: 220, height: 169, rotation: 0, imageRotation: 0 },
        { id: "5", x: 856, y: 533, width: 220, height: 169, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-05-h2v3-03",
    name: "PO 03 - H2V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h2_v3_03.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 27, y: 0, width: 513, height: 854, rotation: 0, imageRotation: 0 },
        { id: "2", x: 628, y: 152, width: 220, height: 168, rotation: 0, imageRotation: 0 },
        { id: "3", x: 628, y: 328, width: 220, height: 374, rotation: 0, imageRotation: 0 },
        { id: "4", x: 856, y: 152, width: 220, height: 374, rotation: 0, imageRotation: 0 },
        { id: "5", x: 856, y: 534, width: 220, height: 168, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-05-h2v3-04",
    name: "PO 04 - H2V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h2_v3_04.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 72, y: 75, width: 424, height: 705, rotation: 0, imageRotation: 0 },
        { id: "2", x: 615, y: 161, width: 452, height: 340, rotation: 0, imageRotation: 0 },
        { id: "3", x: 615, y: 509, width: 107, height: 185, rotation: 0, imageRotation: 0 },     
        { id: "4", x: 730, y: 509, width: 222, height: 185, rotation: 0, imageRotation: 0 },
        { id: "5", x: 960, y: 509, width: 107, height: 185, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-05-h2v3-05",
    name: "PO 05 - H2V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h2_v3_05.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 76, y: 162, width: 411, height: 312, rotation: 0, imageRotation: 0 },
        { id: "2", x: 76, y: 482, width: 272, height: 211, rotation: 0, imageRotation: 0 },
        { id: "3", x: 356, y: 482, width: 131, height: 211, rotation: 0, imageRotation: 0 },
        { id: "4", x: 607, y: 223, width: 241, height: 408, rotation: 0, imageRotation: 0 },
        { id: "5", x: 856, y: 223, width: 241, height: 408, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-05-h2v3-06",
    name: "PO 06 - H2V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h2_v3_06.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 52, y: 237, width: 229, height: 380, rotation: 0, imageRotation: 0 },
        { id: "2", x: 289, y: 237, width: 228, height: 380, rotation: 0, imageRotation: 0 },       
        { id: "3", x: 612, y: 237, width: 237, height: 186, rotation: 0, imageRotation: 0 },
        { id: "4", x: 612, y: 431, width: 237, height: 186, rotation: 0, imageRotation: 0 },
        { id: "5", x: 857, y: 237, width: 236, height: 380, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-05-h2v3-07",
    name: "PO 07 - H2V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h2_v3_07.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 31, y: 217, width: 263, height: 419, rotation: 0, imageRotation: 0 },
        { id: "2", x: 302, y: 217, width: 263, height: 419, rotation: 0, imageRotation: 0 },
        { id: "3", x: 573, y: 217, width: 263, height: 419, rotation: 0, imageRotation: 0 },
        { id: "4", x: 844, y: 217, width: 262, height: 206, rotation: 0, imageRotation: 0 },
        { id: "5", x: 844, y: 431, width: 262, height: 206, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-05-h2v3-08",
    name: "PO 08 - H2V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h2_v3_08.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 0, y: 158, width: 709, height: 537, rotation: 0, imageRotation: 0 },
        { id: "2", x: 717, y: 158, width: 420, height: 312, rotation: 0, imageRotation: 0 },
        { id: "3", x: 717, y: 478, width: 135, height: 217, rotation: 0, imageRotation: 0 },
        { id: "4", x: 860, y: 478, width: 134, height: 217, rotation: 0, imageRotation: 0 },
        { id: "5", x: 1002, y: 478, width: 134, height: 217, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-05-h2v3-09",
    name: "PO 09 - H2V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h2_v3_09.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 34, y: 206, width: 261, height: 441, rotation: 0, imageRotation: 0 },
        { id: "2", x: 303, y: 206, width: 261, height: 217, rotation: 0, imageRotation: 0 },
        { id: "3", x: 303, y: 431, width: 261, height: 216, rotation: 0, imageRotation: 0 },
        { id: "4", x: 572, y: 206, width: 261, height: 441, rotation: 0, imageRotation: 0 },
        { id: "5", x: 841, y: 206, width: 261, height: 441, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-05-h2v3-10",
    name: "PO 10 - H2V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-05-h2_v3_10.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 0, y: 192, width: 278, height: 470, rotation: 0, imageRotation: 0 },
        { id: "2", x: 286, y: 192, width: 278, height: 470, rotation: 0, imageRotation: 0 },
        { id: "3", x: 858, y: 192, width: 278, height: 470, rotation: 0, imageRotation: 0 },
        { id: "4", x: 572, y: 192, width: 278, height: 231, rotation: 0, imageRotation: 0 },
        { id: "5", x: 572, y: 431, width: 278, height: 231, rotation: 0, imageRotation: 0 }
    ],
}
];